import styled from '@emotion/styled';
import { animated } from '@react-spring/web';
import { isSmallSlider } from '../Slider/utils';
export const AnimatedThumbWrapper = styled(animated.div) `
  display: flex;
  flex-direction: row;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: relative;
`;
export const ThumbWrapper = styled.div `
  width: ${({ itemsCount, theme }) => isSmallSlider(theme) ? 'auto' : `${100 / itemsCount}%`};
`;
export const ThumbsContainer = styled.div `
  width: 100%;

  ${({ theme, bottomThumbs }) => (isSmallSlider(theme) && !bottomThumbs) &&
    `
      position: absolute;
      bottom: ${theme.space[2]};
  `};
`;
